import { Modal } from "ui";

import { useCreateFaqItem, useUpdateFaqItem } from "../../../apis";
import { FAQItemForm, FAQItemFormValues } from "../../forms";
import { FAQItemModalProps } from "./FAQItemModal.types";

import styles from "./FAQItemModal.module.scss";

const FAQ_ITEM_FORM_ID = "faq-item-form-id";

const FAQItemModal = ({ isOpen, onClose, editableItem }: FAQItemModalProps) => {
  const createFaqItem = useCreateFaqItem({ onSuccess: onClose });
  const updateFaqItem = useUpdateFaqItem({ onSuccess: onClose });

  const handleFormSubmit = (formData: FAQItemFormValues) => {
    if (editableItem) {
      updateFaqItem.mutate({ id: editableItem.id, ...formData });
    } else {
      createFaqItem.mutate(formData);
    }
  };

  return (
    <Modal
      formId={FAQ_ITEM_FORM_ID}
      isOpen={isOpen}
      title={`${editableItem ? "Edit" : "Add"} Question`}
      isLoading={createFaqItem.isLoading || updateFaqItem.isLoading}
      okText={editableItem ? "Save" : "Add"}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <FAQItemForm
        key={editableItem?.id ?? "new"}
        formId={FAQ_ITEM_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={{
          question: editableItem?.question ?? "",
          answer: editableItem?.answer ?? "",
          isEnabled: editableItem?.isEnabled ?? true
        }}
      />
    </Modal>
  );
};

export default FAQItemModal;
